/**
 * Returns true when an error represents an HTTP 404 Not Found.
 *
 * A 404 is expected user behavior — a route `validate` miss, a not-found
 * detail fetch, or a hand-off to Nuxt's error page — not a server fault. We
 * filter these out of Sentry so they don't create noise events, while every
 * other status (403, 410, 500, network errors, etc.) still reports.
 *
 * Duck-typed defensively: Nuxt/H3 errors expose `statusCode`, our `ApiError`
 * exposes `status`. Handles null/undefined/non-object inputs safely.
 *
 * Lives in `shared/` so both the app-side Sentry plugin (`@sentry/vue`) and
 * the Nitro server plugin (`@sentry/node`) can import it explicitly.
 */
export function isExpected404(err: unknown): boolean {
  if (err === null || typeof err !== 'object') return false;
  const candidate = err as { statusCode?: unknown; status?: unknown };
  return candidate.statusCode === 404 || candidate.status === 404;
}
